'use client';

import { createBrowserClient } from '@supabase/ssr';

// ── Supabase browser client factory ──────────────────────────────────────────
// Uses Supabase's default storage (localStorage) for maximum compatibility.
// Custom cookie overrides caused session loss in sandboxed/iframe environments
// because the cookie availability test returned false, falling back to a
// prefixed localStorage scheme that Supabase's own getSession() couldn't read.
//
// By removing the custom cookies config, Supabase uses its built-in
// localStorage adapter which is consistent across all environments.
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        // Persist session in storage so it survives browser restarts
        persistSession: true,
        // Automatically refresh the token before it expires
        autoRefreshToken: true,
        // Detect session from URL (for OAuth/magic link callbacks)
        detectSessionInUrl: true,
        // Use pkce flow for better security
        flowType: 'pkce',
      },
    }
  );
}
